import { render } from "./MMAdminMemberAnswer.vue?vue&type=template&id=5a6e243c"
import script from "./MMAdminMemberAnswer.vue?vue&type=script&lang=js"
export * from "./MMAdminMemberAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__